module.exports = __webpack_public_path__ + "static/media/21.5494c6ac.JPG";